

















































































































































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import HasValidation from "@/mixins/HasValidation";
import { IPromotionForm } from "@/models/promotions";

@Component
export default class AvailabilityAndEligibility extends Mixins(HasValidation) {
  // Props
  @Prop({ required: true })
  public value!: IPromotionForm;

  @Prop({ required: true })
  public isDisabled!: boolean;

  // Data
  public maxUses = "unlimited";
  public maxUsesPerClient = "unlimited";
  public recurringCount = "non_recurring";
  public form = this.value;

  public created() {
    this.$watch(
      "value",
      val => {
        this.form = val;
      },
      { deep: true }
    );
    this.$watch("form", form => this.$emit("input", form), { deep: true });

    this.maxUses =
      this.form.max_uses === 0
        ? "unlimited"
        : this.form.max_uses === 1
        ? "single"
        : "multiple";

    this.maxUsesPerClient =
      this.form.max_uses_per_client === 0
        ? "unlimited"
        : this.form.max_uses_per_client === 1
        ? "single"
        : "multiple";

    this.recurringCount =
      this.form.promo_recurring_count === -1
        ? "unlimited"
        : this.form.promo_recurring_count === 0
        ? "non_recurring"
        : "multiple";
  }

  public onMaxUsesChange(fieldName: string, value: any) {
    this.form[fieldName] =
      value === "single" ? 1 : value === "unlimited" ? 0 : 2;
  }

  public onRecurringCountChange(value: any) {
    this.form["promo_recurring_count"] =
      value === "non_recurring" ? 0 : value === "unlimited" ? -1 : 1;
  }
}
